/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Container from '@mui/material/Container';
import ErrorIcon from '@mui/icons-material/Error';

function ErrorMessageWrapper({ children, containerStyles = {} }) {
  return (
    <Container
      disableGutters
      sx={{ display: 'flex', pt: 2, pb: 2, gap: 2, ...containerStyles }}
    >
      <ErrorIcon sx={{ color: 'error.main' }} />
      {children}
    </Container>
  );
}

export default ErrorMessageWrapper;
